/**
 * `@atlas/text` — Atlas internationalization package.
 *
 * Locales are 2-letter BCP-47 tags (`en`, `es`, `pt`, `fr`, `de`), `en` is
 * canonical and the fallback for everything else.
 *
 * React code uses the context-based API (`IntlProvider` / `useIntl` /
 * `FormattedMessage`); non-React code uses `t()` after `setupLocale()`.
 */

export * from "./locales";
export * from "./intl";
export * from "./provider";

export { t as default } from "./intl";
